import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import Reservation           from "../../../domain/reservation/Reservation";
import ReservationRepository from "../../../domain/reservation/ReservationRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import ReservationDataSource from "../../../infrastructure/datasource/reservation/ReservationDataSource";
import GetReservations       from "./GetReservations";

class RegisterReservation {
  private readonly repository: ReservationRepository = new ReservationDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly getReservations: GetReservations = new GetReservations(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(reservation: Reservation) {
    this.fetchStatusRepository.start();
    try {
      await this.repository.register(reservation);
      await this.getReservations.execute(reservation.detail.date);
      this.notifyRepository.saveSuccess();
    } catch (e) {
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default RegisterReservation;
